import { marked } from 'marked';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

export function renderSafeMarkdown(text) {
    const html = marked.parse(text ?? '', { breaks: true });

    return DOMPurify.sanitize(html, {
        ADD_ATTR: ['target'],
    });
}
